export enum EnergyCertificateAvailability {
  NOT_REQUIRED = 'NOT_REQUIRED',
  NOT_AVAILABLE_YET = 'NOT_AVAILABLE_YET',
  AVAILABLE = 'AVAILABLE',
}
